import { Component, OnDestroy, OnInit } from "@angular/core";
import { getApp } from "../../app";
import { Subscription } from "rxjs";
import { StringUtils } from "../../../../../shared/utils/string.utils";
import { FilterMode } from "./OC-home.service.type";
import { ActivatedRoute } from "@angular/router";
import { ocPosts, getFilteredOCPosts } from "../../../app/api.service";
import { OCPost } from "../../../../../shared/models/obsolescence-community/OC-Post";

@Component({
  selector: "app-oc-home",
  templateUrl: "./OC-home.component.html",
  styleUrls: ["./OC-home.component.scss"],
})
export class OCHomeComponent implements OnInit, OnDestroy {
  updatePostsSubscription: Subscription = new Subscription();
  filterModes: FilterMode[] = ["title", "tag", "message", "user_id"];
  loading = false;
  noMorePosts = false;

  app = getApp((app) => {
    this.app = app;
  });

  constructor(private route: ActivatedRoute) {}

  async ngOnInit() {
    this.app.routing.setTabTitle("Obsolescence Community");
    this.app.OCHome.tags = this.app.field.getOptions(
      this.app.fieldId.ocPost.tagCategory
    );

    // populate post model with all needed information
    await this.app.OCHome.ocPosts();

    // TODO: remove this after user managerment chages are integrated
    this.updatePostsSubscription = this.app.OCHome.updatePostsSubject.subscribe(
      async (value) => {
        if (value) {
          if (!this.app.change.fromAlert) {
            await this.app.OCHome.ocPosts();
          }
        }
      }
    );

    /** when we login or navigate from another page we dont know the last postId,
     * only after we take all the posts with ocPosts we know the id, so we have to
     * add it to the URL
     */
    if (this.route.snapshot.params.postId == null) {
      this.app.routing.navigateOCPost(this.app.OCPost.selectedPost._id);
    } else {
      // when comming from the notification we have to set the selectedPost, based on the postId from the URL
      // TODO: create an api to take only the needed post based on postId
      if (this.app.OCHome.posts != null) {
        const notificationPost = this.app.OCHome.posts.find(
          (post: any) => post._id === this.route.snapshot.params.postId
        );
        if (notificationPost != null) {
          this.app.OCPost.selectedPost = notificationPost;
        }
      }
    }
    this.app.OCPost.updatePostSubject.next(true);
    this.app.change.fromAlert = false;
  }

  async onScroll(event: any): Promise<void> {
    const element = event.target;
    const nearBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 100;

    if (
      nearBottom &&
      !this.loading &&
      !this.noMorePosts &&
      !this.app.OCHome.refreshingPosts
    ) {
      this.loading = true;
      this.app.OCHome.pageNumber += 1;
      let newPosts: OCPost[] = [];

      if (!this.app.OCHome.isFilterSelected) {
        newPosts = await ocPosts(
          this.app.customers.expectCurrent,
          this.app.OCHome.pageNumber,
          this.app.OCHome.limit
        );
      } else {
        newPosts = await getFilteredOCPosts(
          this.app.customers.expectCurrent,
          this.app.OCHome.selectedType,
          this.app.OCHome.searchWords[this.app.OCHome.selectedType],
          this.app.OCHome.pageNumber,
          this.app.OCHome.limit
        );
      }

      // If no posts returned or less than limit -> stop further loading
      if (!newPosts.length || newPosts.length < this.app.OCHome.limit) {
        this.noMorePosts = true;
      }

      // Append new posts
      this.app.OCHome.posts = [...this.app.OCHome.posts, ...newPosts];
      this.loading = false;
    }
  }

  setType(type: string) {
    this.app.OCHome.selectedType = type;
    if (this.app.OCHome.isFilterSelected) {
      this.clearFilter();
    }
  }

  getTextDisplay(value: string) {
    switch (value) {
      case "user_id":
        return this.app.text.ocPost.own;
      case "title":
        return this.app.text.ocPost.title;
      case "message":
        return this.app.text.ocPost.description;
      case "tag":
        return "Category";
    }
  }

  isSelected(filter: string) {
    this.app.OCHome.selectedValue = this.app.OCHome.searchWords[filter];
    if (!StringUtils.isNullOrEmpty(this.app.OCHome.selectedValue)) {
      this.app.OCHome.isFilterSelected = true;
    } else {
      this.app.OCHome.isFilterSelected = false;
    }
    return this.app.OCHome.isFilterSelected;
  }

  async clearFilter() {
    this.app.OCHome.selectedValue = "";
    this.app.OCHome.isFilterSelected = false;
    this.app.OCHome.searchWords = {};
    this.app.OCHome.pageNumber = 1;
    this.noMorePosts = false;
    await this.app.OCHome.updateOCPosts();
    this.app.OCPost.selectedPost = this.app.OCHome.posts[0];
    this.app.OCPost.updatePostSubject.next(true);
  }

  ngOnDestroy() {
    if (this.updatePostsSubscription) {
      this.updatePostsSubscription.unsubscribe();
    }
    this.app.OCHome.isFilterSelected = false;
    this.app.OCHome.searchWords[this.app.OCHome.selectedType] = "";
  }
}
